import { Chip } from '@mui/material';

import { STATUS_COLORS } from 'constants/real-estates';

export const StatusChip: React.FC<{ status: string }> = ({ status }) => {
  return <Chip label={status} color={STATUS_COLORS[status]}></Chip>;
};
